<template>
	<div v-if="activities" class="py-8">
		<Timeline :value="allActivities" class="-ml-[100%]">
			<template #content="slotProps">
				<HistoryTimelineCard :item="slotProps.item" :index="slotProps.index"/>
			</template>
		</Timeline>
	</div>
</template>

<script>
import { mapStores } from "pinia";
import { useCompaniesStore } from "@/stores/companies.js";
import HistoryTimelineCard from "@/Components/HistoryTimelineCard.vue";

export default {
	name: "CompanyHistoryView",
	components: {HistoryTimelineCard},
	data() {
		return {
			activities: undefined,
		}
	},
	computed: {
		...mapStores(useCompaniesStore),
		allActivities() {
			return [
				...this.activities,
			].sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));
		},
	},
	methods: {
		async refreshCompany() {
			return this.companiesStore.showCompany(this.$route.params.company, {
				fields: {companies: 'id'},
				include: ['activities.causer'],
			});
		},
	},
	watch: {
		'$route.params.company': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.company === 'NEW') {
						this.activities = [];
					} else {
						const response = (await this.refreshCompany());
						this.activities = response.activities;
					}
				} else {
					this.activities = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>